import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FiltroSelectOption } from '../filtro-select/filtro-select.component';

@Component({
  selector: 'app-filtro-select-busca',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './filtro-select-busca.component.html',
  styleUrl: './filtro-select-busca.component.scss',
})
export class FiltroSelectBuscaComponent {
  @Input() value: any = 0;
  @Input() options: FiltroSelectOption[] = [];
  @Input() placeholder = 'Selecionar';
  @Input() placeholderBusca = 'Buscar...';
  @Input() disabled = false;
  @Input() multi = false;
  @Input() selectedValues: any[] = [];

  @Output() valueChange = new EventEmitter<any>();
  @Output() selectedValuesChange = new EventEmitter<any[]>();

  aberto = false;
  termoBusca = '';

  constructor(private readonly elementRef: ElementRef) {}

  get temSelecao(): boolean {
    return this.multi
      ? this.selectedValues.length > 0
      : this.options.some((o) => o.value === this.value);
  }

  get rotuloSelecionado(): string {
    if (this.multi) {
      if (this.selectedValues.length === 0) {
        return this.placeholder;
      }

      if (
        this.options.length > 0 &&
        this.selectedValues.length === this.options.length
      ) {
        return 'Todos os contatos selecionados';
      }

      const selecionados = this.options.filter((o) =>
        this.selectedValues.includes(o.value)
      );

      if (selecionados.length === 1) {
        return selecionados[0].label;
      }

      return `${selecionados.length} contato(s) selecionado(s)`;
    }

    return this.options.find((o) => o.value === this.value)?.label ?? this.placeholder;
  }

  get opcoesFiltradas(): FiltroSelectOption[] {
    const termo = this.normalizar(this.termoBusca);
    if (!termo) return this.options;
    return this.options.filter((o) => this.normalizar(o.label).includes(termo));
  }

  private normalizar(texto: string): string {
    return (texto ?? '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  isSelected(option: FiltroSelectOption): boolean {
    return this.multi
      ? this.selectedValues.includes(option.value)
      : option.value === this.value;
  }

  toggle(): void {
    if (this.disabled) return;

    this.aberto = !this.aberto;
    if (this.aberto) this.termoBusca = '';
  }

  selecionar(option: FiltroSelectOption): void {
    if (this.multi) {
      const index = this.selectedValues.indexOf(option.value);

      if (index >= 0) {
        this.selectedValues = [
          ...this.selectedValues.slice(0, index),
          ...this.selectedValues.slice(index + 1),
        ];
      } else {
        this.selectedValues = [...this.selectedValues, option.value];
      }

      this.selectedValuesChange.emit(this.selectedValues);
    } else {
      this.value = option.value;
      this.aberto = false;
      this.termoBusca = '';
      this.valueChange.emit(option.value);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.aberto && !this.elementRef.nativeElement.contains(event.target)) {
      this.aberto = false;
    }
  }
}
